import { BlockReleaseApiResponse } from '@data/blockReleases/types/BlockRelease.types';
import { BlockReleaseState } from '@data/blockReleases/types/BlockReleaseState';
import SlotResponse from '@data/schedules/types/SlotResponse';
import { utcToTimezone } from '@utilities/dateUtilities';

export const convertBlockInfoToReleaseObject = (
	block: Omit<SlotResponse, 'owners'>,
	hospitalName: string,
	surgeonNpi: string,
	hospitalTimeZone: string,
): BlockReleaseApiResponse => {
	return {
		id: block.id,
		slotId: block.id,
		slotName: block.name,
		hospitalName: hospitalName,
		unit: block.unit,
		unitId: block.unit,
		endDateTime: block.end,
		startDateTime: block.start,
		blockEndTime: utcToTimezone(block.end, hospitalTimeZone, 'HH:mm'),
		blockStartTime: utcToTimezone(block.start, hospitalTimeZone, 'HH:mm'),
		state: BlockReleaseState.NOT_RELEASED,
		npis: [surgeonNpi],
		releasedBy: '',
		requestedBy: '',
		releasedTs: '',
		requestedTs: '',
		description: '',
		room: '',
	};
};
